module.exports = "---\nsummary: Manage your accounts and the users within those accounts.\n---\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/reference/content/happyco.manage.account.v1/overview.md
// module id = 243
// module chunks = 0